// initialValues.js
const nakshraInitialValues = {
  start_time: "",
  end_time: "",
  name: "",
};
export default nakshraInitialValues;
